export const SAVE_FILTER_VALUE = 'SAVE_FILTER_VALUE';

export function saveFilterValue(value) {
	return {
		type: SAVE_FILTER_VALUE,
		payload: value,
	};
}
